import { Component } from "@angular/core";
import { FieldWrapper, FormGlobalService } from "@kre-form/core";

import { PickerController, PopoverController } from "@ionic/angular";
import { KreFormFieldIonTagsComponent } from "../components/tags_component";
@Component({
  selector: "kreform-wrapper-ion-form-field",
  template: `
    <ng-container *ngIf="field.type != 'html'">
      <div class="item-box">
        <ng-container
          *ngIf="
            field.type != 'line' &&
            field.type != 'htmlcontent' &&
            field.type != 'image' &&
            field.type != 'label' &&
            field.type != 'upload' &&
            field.type != 'radio' &&
            field.type != 'checkbox'
          "
        >
          <ion-label
            [position]="to.labelPosition"
            [ngStyle]="{
              color: fontProperty.color,
              'font-size': fontProperty.fontSize + 'px',
              'font-style': fontProperty.fontStyle ? 'italic' : 'normal',
              'font-weight': fontProperty.fontWeight ? 'bold' : 'normal'
            }"
          >
            <span *ngIf="to.required" class="required-icon">*</span
            >{{ to.label }}
          </ion-label>
        </ng-container>
        <div class="field-content-box">
          <ng-template #fieldComponent></ng-template>
          <div
            class="field-unit"
            *ngIf="to.unit && to.unit != null && to.unit != ''"
          >
            <span [innerHtml]="to.unit | safeHtml"></span>
          </div>
          <div
            class="field-button"
            *ngIf="to.button && to.button != null && to.button?.show == true"
          >
            <span
              [innerHtml]="to.button.label | safeHtml"
              (click)="buttonClick()"
            ></span>
          </div>
        </div>
      </div>

      <div class="item-error" *ngIf="showError">
        <kreform-validation-message [field]="field">
        </kreform-validation-message>
      </div>
      <ng-container *ngIf="tags.mark">
        <ion-badge class="field-tags" (click)="onBadge(tags)">
          {{ tags.mark | tags }}
        </ion-badge>
      </ng-container>
    </ng-container>
  `,
})
export class KreFormWrapperFormField extends FieldWrapper {
  constructor(
    protected popoverController: PopoverController,
    private globalService: FormGlobalService
  ) {
    super();
  }

  async onBadge(tags) {
    let result = "";
    switch (tags.mark) {
      case "add":
        result = "新增";
        break;
      case "modify":
        result = "修改";
        break;
      case "remove":
        result = "删除";
        break;
      default:
        break;
    }

    const popover = await this.popoverController.create({
      component: KreFormFieldIonTagsComponent,
      cssClass: "field-popover",
      componentProps: {
        content: this.tags.content || `数据已被${result}`,
      },
      translucent: true,
      mode: "ios",
    });
    await popover.present();
  }

  buttonClick() {
    this.globalService.notifyDataChanged("FieldWrapperClick", {
      rdm: Math.random(),
      config: this.field,
    });
  }
}
